import { PDFDownloadLink } from '@react-pdf/renderer'
import React, { useState } from 'react'
import Panel from './Panel'
import AnalyzeDataPDF from '../PDF/AnalyzeDataPDF'
import { Risk } from '../model/Risk'
import { AnalyzeData } from '../model/AnalyzeData'
import { RiskUI } from '../model/RiskUI'

export const riskLevel = (risk: Risk): RiskUI => {
    const level = risk.probability * risk.effect;

    if (level < 5) {
        return {text: "Niskie", value: "25%"};
    }
    else if (level < 9) {
        return {text: "Średnie", value: "50%"};
    }
    else if(level < 13) {
        return {text: "Wysokie", value: "75%"};
    }
    else if(level < 17) {
        return {text: "Bardzo wysokie", value: "100%"};
    }
    
    return {
        text: '', value: ''
    }
}

export default function AnalyseCalc() {


    const newRisk = (id: number): Risk => {
            return {
                name: '',
                effect: 1,
                id: id,
                probability: 1,
                recommendations: '',
                risk: '',
                source: '',
                wayOfDeal: '',
                weight: 1
            }
        }
    
      const [data, setData] = useState<AnalyzeData>({
        groupOfResources: '',
        vulnerability: '',
        organisationalProtection: '',
        resource: '',
        risks: [newRisk(1)],
        technicalProtection: ''
      });
    
      const changeRisk = (id: number, prop: string, e: any) => {
        const newRisk = data.risks.map(x => {
          if(x.id !== id) return x;
    
          return ({
            ...x,
            [prop]: e.target.value
          })
        })
    
        setData({...data, risks: newRisk})
      }
    
      const changeDataValue = (field: string, e: any) => {
        setData({
            ...data,
            [field]: e.target.value
        })
      }
    
      const riskName = (value: number) => {
        if(value == 1) return "Małe";
        if(value == 2) return "Średnie";
        if(value == 3) return "Duże";
        if(value == 4) return "Bardzo duże";
      }
    
      const addNewDanger = () => {
        const newId = data.risks.reduce((a, b) => Math.max(a, b.id), 0);
        setData({...data, risks: [...data.risks, newRisk(newId + 1)]})
      }
    
      const document = () => {
        return (
            <AnalyzeDataPDF {...data} />
        )
      }
    
  return (
    <div>
        <div className="row">
            <div className="col text-center">
                <h3 className="text-dark-gray fw-700 ls-minus-1px">Wykonaj analizę ryzyka dla swojej firmy</h3>
            </div>
        </div>
        <div className='row'>
            <Panel header='1. Analizowane zasoby'>
                <div>
                    <label className="text-medium-gray mb-10px">Rodzaj (grupa) zasobów</label>
                    <select value={data.groupOfResources ?? 1} className="form-select mb-10px" onChange={e => changeDataValue("groupOfResources", e)}>
                        <option value={1} disabled>Wybierz rodzaj (grupę) zasobów</option>
                        <option value="Sprzęt/hardware">Sprzęt/hardware</option>
                        <option value="Oprogramowanie/software">Oprogramowanie/software</option>
                        <option value="Sieć/network">Sieć/network</option>
                        <option value="Pracownicy">Pracownicy</option>
                        <option value="Usługodawcy/osoby trzecie">Usługodawcy/osoby trzecie</option>
                        <option value="Miejsca i lokalizacje">Miejsca i lokalizacje</option>
                        <option value="Dokumentacja papierowa">Dokumentacja papierowa </option>
                    </select>
                </div>
                <div>
                    <fieldset>
                        <label className="text-medium-gray mb-10px">Nazwa rodzaju (grupy) zasobów</label>
                        <input className="form-control mb-10px" value={data.resource} type="text" onChange={e => changeDataValue("resource", e)} placeholder="Nazwij rodzaj (grupę) zasobów, który analizujesz" />
                    </fieldset>
                </div>
            </Panel>
        </div>
        <div className='row'>
            <Panel header='2. Zagrożenia dla poufności, integralności lub dostępności przetwarzania danych'>
                <div>
                    {data.risks.map(x => {
                        return (
                            <div key={x.id} className="row border-bottom">
                                <div className="col-lg-6">
                                    <label className="text-medium-gray mb-10px">Zagrożenia</label>
                                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={x.name} onChange={e => changeRisk(x.id, "name", e)} />
                                </div>
                                <div className="col-lg-6">
                                    <label className="text-medium-gray mb-10px">Źródło zagrożeń</label>
                                    <select value={x.source ? x.source : 1} className="form-select border-white fs-16 box-shadow-large mb-10px" onChange={e => changeRisk(x.id, "source", e)}>
                                        <option value={1} disabled>Wybierz odpowiedź</option>
                                        <option value="Wewnętrzne">Wewnętrzne (firma)</option>
                                        <option value="Mieszane">Mieszane (firma i spoza firmy)</option>
                                        <option value="Zewnętrzne">Zewnętrzne (spoza firmy)</option>
                                    </select>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="row" style={{ marginTop: "1.0rem"}}>
                    <div className="col">
                        <button type="button" className="btn btn-medium btn-dark-gray btn-box-shadow btn-round-edge text-transform-none primary-font" onClick={addNewDanger}>Dodaj</button>
                    </div>
                </div>
            </Panel>
        </div>
        <div className='row'>
            <Panel header='3. Zabezpieczenia do przeciwdziałania tym zagrożeniom'>
                <div>
                    <label className="text-medium-gray mb-10px">Zabezpieczenia techniczne, np. logowanie 2FA, backup danych, szyfrowanie danych, monitoring, antywirus, ochrona IT, itp.</label>
                    <input className="form-control border-white fs-16 box-shadow-large mb-10px" type="text" value={data.technicalProtection} onChange={e => changeDataValue("technicalProtection", e)} placeholder="Opis stosowanych zabezpieczeń technicznych" />
                </div>
                <div>
                    <label className="text-medium-gray mb-10px" >Zabezpieczenia organizacyjne, np. procedury, polityki, uprawnienia, upoważnienia, szkolenia pracowników, itp.</label>
                    <input className="form-control border-white fs-16 box-shadow-large mb-10px" type="text" value={data.organisationalProtection} onChange={e => changeDataValue("organisationalProtection", e)} placeholder="Opis stosowanych zabezpieczeń organizacyjnych" />
                </div>
            </Panel>
        </div>
        <div className='row'>
            <Panel header='4. Luki (możliwe uchybienia, podatności)'>
                <div>
                    <label className="text-medium-gray mb-10px">Wskaż możliwe luki, np. BRAK: 2FA, backupu danych, szyfrowania danych, monitoringu, antywirusów, ochrony IT, procedur, uprawnień, szkoleń, itp.</label>
                    <input value={data.vulnerability} onChange={e => changeDataValue("vulnerability", e)} className="form-control border-white fs-16 box-shadow-large mb-10px" type="text" placeholder="Opisz możliwe luki (uchybienia, podatności)" />
                </div>
            </Panel>
        </div>
        <div className='row'>
            <Panel header='5. Oszacuj prawdopodobieństwo zagrożeń'>
                <div>
                    {data.risks.map((x, i) => {
                        return (
                            <div key={x.id} className={`row mb-15px ${i !== data.risks.length - 1 ? "border-bottom border-2 border-color-gray" : ""}`}>
                                <div className='col-lg-12'>
                                    <div className='progress-bar-style-02'>
                                        <div className='progress mb-15px border-radius-50px fw-700 fs-11 lh-11 text-white bg-white'>
                                            <div className="progress-bar bg-gradient-flamingo-red-transparent m-0 appear" role="progressbar" aria-valuenow={98} aria-valuemin={0} aria-valuemax={100} aria-label="business" style={{width: riskLevel(x).value}} />
                                            <div className="progress-bar-title text-uppercase">{riskLevel(x).text}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <label className="text-medium-gray">Zagrożenia</label>
                                    <p>{x.name}</p>
                                </div>
                                <div className="col-lg-4">
                                    <label className="text-medium-gray">Prawdopodobieństwo - {riskName(x.probability)}</label>
                                    <input type="range" className='calc-range' min="1" max="4" step="1" value={x.probability} onChange={e => changeRisk(x.id, "probability", e)} />
                                </div>
                                <div className="col-lg-3">
                                    <label className="text-medium-gray">Skutki - {riskName(x.effect)}</label>
                                    <input type="range" className='calc-range' min="1" max="4" step="1" value={x.effect} onChange={e => changeRisk(x.id, "effect", e)} />
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div></div>
            </Panel>
        </div>
        <div className='row'>
            <Panel header='6. Działania do podjęcia, zaplanowany sposób reakcji na zagrożenia'>
                    <div className="row mb-15px">
                        <span>Napisz co zamierzasz zrobić, aby zminimalizować te zagrożenia</span>
                    </div>
                    <div>
                        {data.risks.map(x => {
                            return (
                                <div key={x.id} className="row mb-15px">
                                    <div className="col-lg-3">
                                        <label className="text-medium-gray mb-25px">Zagrożenia</label>
                                        <p>{x.name}</p>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className='progress-bar-style-02'>
                                            <div className='progress mb-15px border-radius-50px fw-700 fs-11 lh-11 text-white bg-white'>
                                                <div className="progress-bar bg-gradient-flamingo-red-transparent m-0 appear" role="progressbar" aria-valuenow={98} aria-valuemin={0} aria-valuemax={100} aria-label="business" style={{width: "100%"}} />
                                                <div className="progress-bar-title text-uppercase">{riskLevel(x).text}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="text-medium-gray mb-25px">Działania do podjęcia</label>
                                        <select value={x.wayOfDeal ? x.wayOfDeal : "Akceptacja"} onChange={e => changeRisk(x.id, "wayOfDeal", e)} className="form-select intensity">
                                            <option value="Akceptacja">Akceptacja</option>
                                            <option value="Obniżanie">Obniżanie (dodatkowe zabezpieczenia)</option>
                                            <option value="Transfer">Transfer (przeniesienie zarządzania zasobami na inny podmiot)</option>
                                            <option value="Unikanie">Rezygnacja z wykorzystania zasobów</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="text-medium-gray mb-25px">Zalecenia</label>
                                        <textarea value={x.recommendations} onChange={e => changeRisk(x.id, "recommendations", e)} className="form-control border-white fs-16 box-shadow-large" rows={3} />
                                    </div>
                                </div>
                            )
                        })} 
                    </div>
            </Panel>
        </div>
        <div className="row text-right">
            <div className='calc-pdf-btn'>
                <PDFDownloadLink className='btn btn-medium btn-dark-gray btn-box-shadow btn-round-edge text-transform-none primary-font submit' document={document()}>Zapisz do pliku PDF</PDFDownloadLink>
            </div>
        </div>
    </div>
  )
}